import React, { useEffect, useMemo } from 'react';
import CustomSelect from '../../components/CustomSelect';
import { RatingType } from '../../types';
import {
  useGetCustomSelectButtonElement,
  useSetSelectDefaultValue,
} from '../../hooks/init';
import { ratingPlaceholder } from '../../constants/placeholder';
import { commonBackInfo } from '../../utils';
import './index.scss';
import { useIntl } from 'umi';
import SvgIcon from '@home/components/SvgIcon';
import { getSentimentItem } from '../../constants/sentiment';
import { FilterButtonPoint } from '@op/operationLog/pages/filter';

export const ratingIconMap: any = {
  positive: 'good-icon',
  negative: 'no-good-icon',
};
export default function RatingSelect({
  onChange,
  defaultKey,
  defaultValue,
  filterValue,
  lang,
}: RatingType) {
  const { formatMessage } = useIntl();

  const rantingOptions: Array<{
    text: JSX.Element | string;
    value: string;
  }> = useMemo(() => {
    return [
      {
        value: 'positive',
        text: getSentimentItem('good-icon', formatMessage({ id: 'Positive' })),
      },
      {
        value: 'negative',
        text: getSentimentItem(
          'no-good-icon',
          formatMessage({ id: 'Negative' }),
        ),
      },
    ];
  }, [formatMessage]);

  const {
    selects: selectRating,
    setSelects: setSelectRating,
    diffClassName,
  } = useSetSelectDefaultValue<string>({
    defaultValue,
    filterValue,
    defaultKey: 'reviews_rating',
    options: rantingOptions.map((item) => item.value),
    finallyDealwithSelected: (selected: Array<string>) => {
      return selected.filter((item) => item !== 'mixed');
    },
  });
  const { customSelectRef, getButtonElement } =
    useGetCustomSelectButtonElement();
  useEffect(() => {
    const [text, isAll] = getButtonElement();
    onChange?.(
      'rating',
      commonBackInfo(
        { reviews_rating: selectRating },
        { [defaultKey]: text },
        { isAll, needChangeEntity: true },
      ),
    );
  }, [selectRating, formatMessage]);

  return (
    <div className={`steam-rating-select-wrapper ${diffClassName}`}>
      <CustomSelect
        ref={customSelectRef}
        buttonItemRender={(value: any) => {
          const item = rantingOptions.find((item) => item.value === value);
          return item.text;
        }}
        buttonAllRender={['positive', 'negative'].map((value) => (
          <SvgIcon
            key={value}
            type={ratingIconMap[value]}
            className="dbo-select-icon"
          />
        ))}
        matchButtonWidth
        boxClassName={'steam-rating-select-box'}
        placeholderText={ratingPlaceholder[lang]}
        onClear={() => setSelectRating([])}
        selectOptionsInfo={[selectRating, setSelectRating]}
        options={rantingOptions}
        pointKey={FilterButtonPoint.steamRating}
      ></CustomSelect>
    </div>
  );
}
